module.exports = __webpack_public_path__ + "img/minus_btn.73d33241.png";